import { render, staticRenderFns } from "./FormElementLongTextInput.vue?vue&type=template&id=80b44b02&"
import script from "./FormElementLongTextInput.vue?vue&type=script&lang=js&"
export * from "./FormElementLongTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports